const idOf = value => {
  if (value && value._id) return String(value._id);
  if (value == null || value === '') return '';
  return String(value);
};

export const isPoolPackage = pkg => !!pkg && pkg.groupingType !== 'individual';

export const packageByUnitId = packages => {
  const map = {};
  (packages || []).forEach(pkg => {
    (pkg.units || []).forEach(uid => {
      const id = idOf(uid);
      if (id && !map[id]) map[id] = pkg;
    });
  });
  return map;
};

export const poolPackageIdsForUnits = (packages, unitIds) => {
  const wanted = new Set((unitIds || []).map(id => String(id)).filter(Boolean));
  const byUnit = packageByUnitId(packages);
  const ids = [];
  const seen = {};
  wanted.forEach(unitId => {
    const pkg = byUnit[unitId];
    const pkgId = pkg && idOf(pkg._id);
    if (!isPoolPackage(pkg) || !pkgId || seen[pkgId]) return;
    seen[pkgId] = true;
    ids.push(pkgId);
  });
  return ids;
};

/**
 * Pool packages show package inventory (booked units / pool size).
 * Individual packages stay on the single-unit calendar.
 */
export const inventoryForPayoutUnit = ({ unitId, packages, unitInventoryByUnit, packageInventoryById }) => {
  const pkg = packageByUnitId(packages)[String(unitId)];
  if (isPoolPackage(pkg)) {
    return (packageInventoryById && packageInventoryById[idOf(pkg._id)]) || null;
  }
  return (unitInventoryByUnit && unitInventoryByUnit[String(unitId)]) || null;
};
